const ROOT_SELECTOR = '[data-office-tabs]';
const TAB_SELECTOR = '[role="tab"]';
const READY_KEY = 'officeTabsReady';

function initTabs( root ) {
	if ( root.dataset[ READY_KEY ] ) {
		return;
	}
	root.dataset[ READY_KEY ] = 'true';

	const tabs = Array.from( root.querySelectorAll( TAB_SELECTOR ) );
	if ( tabs.length < 2 ) {
		return;
	}

	const select = ( tab, { focus = false, updateHash = false } = {} ) => {
		tabs.forEach( ( item ) => {
			const active = item === tab;
			item.setAttribute( 'aria-selected', String( active ) );
			item.tabIndex = active ? 0 : -1;
			root.querySelector( `#${ item.getAttribute( 'aria-controls' ) }` ).hidden = ! active;
		} );

		if ( focus ) {
			tab.focus();
		}

		if ( updateHash ) {
			history.replaceState( null, '', `#${ tab.dataset.office }` );
		}
	};

	const fromHash = () => {
		const office = decodeURIComponent( window.location.hash.slice( 1 ) );
		const tab = tabs.find( ( item ) => item.dataset.office === office );

		if ( tab ) {
			select( tab );
			root.scrollIntoView();
		}
	};

	tabs.forEach( ( tab, index ) => {
		tab.addEventListener( 'click', () => select( tab, { updateHash: true } ) );
		tab.addEventListener( 'keydown', ( event ) => {
			const keys = {
				ArrowRight: index + 1,
				ArrowLeft: index - 1,
				Home: 0,
				End: tabs.length - 1,
			};

			if ( ! ( event.key in keys ) ) {
				return;
			}

			event.preventDefault();
			const next = tabs[ ( keys[ event.key ] + tabs.length ) % tabs.length ];
			select( next, { focus: true, updateHash: true } );
		} );
	} );

	fromHash();
	window.addEventListener( 'hashchange', fromHash );
}

const OfficeTabs = {
	init( root = document ) {
		root.querySelectorAll( ROOT_SELECTOR ).forEach( initTabs );
	},
};

export default OfficeTabs;
